import { type ComponentPropsWithoutRef,forwardRef } from 'react';

import { cn } from '@/lib/cn';

const DialogBody = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>(
  ({ children, className, ...rest }, ref) => {
    return (
      <div ref={ref} className={cn('overflow-auto px-7', className)} {...rest}>
        {children}
      </div>
    );
  },
);

export default DialogBody;
